import React, { Suspense, lazy } from "react";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import { AppWrapper } from "./AppWrapper";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { installDeviceInterceptor } from "./device/deviceAxios";

// On a paired event-day device every API call goes to the device API
// (device/deviceAxios.js); installed before anything can make a request.
installDeviceInterceptor();

// Where an Oireachtas job device arrives after pairing (card 540f21a4): its
// own small page, outside the signed-in app.
const DeviceIntake = lazy(() => import("./device/DeviceIntake"));
export const isDeviceIntakePath = (path) => /^\/device\/?$/.test(path || "");

function App() {
  if (isDeviceIntakePath(window.location.pathname)) {
    return (
      <Suspense fallback={null}>
        <DeviceIntake />
      </Suspense>
    );
  }

  return (
    <Provider store={store}>
      <AppWrapper />
    </Provider>

  );
}

export default App;
